<!--
 * @Description:
 * @Author: PF
 * @Date: 2023-07-17 15:23:51
-->
<template>
  <div>
    <el-dialog class="wp80 hp80" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">安全培训资料</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
      <el-container>
        <el-header>
          <el-tabs v-model="dataGrid.parms.pxzlxxzt" @tab-change="bindTable()">
            <el-tab-pane label="未学习" :name="0"></el-tab-pane>
            <el-tab-pane label="学习中" :name="1"></el-tab-pane>
            <el-tab-pane label="已完成" :name="9"></el-tab-pane>
          </el-tabs>
          <!-- 搜索区域 BEGIN -->
          <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
            <el-form-item>
              <el-date-picker placeholder="发布日期" v-model="dataGrid.parms.pxzlfbsj" type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD" clearable @change="bindTable()"/>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="培训资料类别" v-model="dataGrid.parms.pxzllbid" clearable filterable @change="bindTable()">
                <el-option v-for="(item, index) in pxzllbData" :key="index" :label="item.bt" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="发布范围" v-model="dataGrid.parms.pxzlfbfwid" clearable filterable @change="bindTable()">
                <el-option v-for="(item, index) in pxzlfbfwData" :key="index" :label="item.bt" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="资料格式" v-model="dataGrid.parms.pxzlgs" clearable filterable @change="bindTable()">
                <el-option v-for="(item, index) in pxzlgsData" :key="index" :label="item.bt" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-form>
        </el-header>
        <el-main>
          <el-row :gutter="20" class="wp100">
            <el-col :span="6" class="mb20" v-for="(item, index) in dataGrid.data" :key="index" @dblclick="openDetail=true; tcRow=item; bindTable()">
              <el-card shadow="hover" class="pointer">
                <el-image class="currentImg" :src="baseurl+item.pxzltb" fit="contain">
                  <template #error>
                    <div class="image-slot">
                      <el-icon><icon-picture /></el-icon>
                    </div>
                  </template>
                </el-image>
                <ul>
                  <li style="font-size: 16px;font-weight: bold;">{{item.pxzlbt}}</li>
                  <li style="font-size: 14px;">资料类别：{{item.pxzllbmc}}</li>
                  <li style="font-size: 14px;">发布日期：{{item.pxzlfbsj}}</li>
                  <li style="font-size: 14px;">发布范围：{{item.pxzlfbfwmc}}</li>
                </ul>
              </el-card>
            </el-col>
          </el-row>
        </el-main>
        <el-footer>
          <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
        </el-footer>
      </el-container>
    </div>
    </el-dialog>
  </div>
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="tcRow" />

</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'

import {
  loadList,
  homeCloseWindow
} from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import detail from './detail.vue'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

const baseurl = ref(process.env.VUE_APP_BASE_API)// 根路径
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'pxzlfbsj', order: 'ascending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/pinganxiaoyuan/pinganxiaoyuanpeixunziliao/geren/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}

// 弹窗
const tcRow = ref({})
const openDetail = ref(false)
const openList = ref(false)

watch(
  () => props.open,
  () => {
    if (props.open === 'anquanpeixunziliao') {
      openList.value = true
      dataGrid.value.parms.pxzlxxzt = 0
      bindTable()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
</script>
